import { immerable } from 'immer';
import type { ItemDTO } from '../dto/item.dto.js';

export abstract class Item implements ItemDTO {
  [immerable] = true;

  _id: string;
  author?: string;
  description?: string;
  image100: string;
  image30: string;
  image600: string;
  image60: string;
  isHostedByFuuze?: boolean;
  pubDate?: Date;
  slug: string;
  title: string;
  visibility: ItemVisibility;

  protected constructor(item: ItemDTO) {
    this._id = item._id.toString();
    this.author = item.author;
    this.description = item.description;
    this.image30 = item.image30;
    this.image60 = item.image60;
    this.image100 = item.image100;
    this.image600 = item.image600;
    this.isHostedByFuuze = item.isHostedByFuuze;
    this.pubDate = item.pubDate;
    this.slug = item.slug;
    this.title = item.title;
    this.visibility = item.visibility as Item['visibility'];
  }

  isVisibilityTiered() {
    return this.visibility !== 'public' && this.visibility !== 'hidden';
  }

  isVisibility(check: ItemVisibility) {
    return this.visibility === check;
  }
}

export type ItemVisibility = 'public' | 'hidden' | (string & {});
